import { IUser } from '@common/interfaces/user'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../../helpers/redux'
import { IAction } from '../../apiMiddleware'
import * as actions from './actions'

/**
 * The minimal user shape the admin list views need. Kept as a `Pick` over the
 * canonical `IUser` so this stays in sync with the user interface.
 */
export type IAtlasUser = Pick<IUser, 'id' | 'firstName' | 'lastName' | 'avatar'>

export interface IAtlasDocSummary {
  id: string
  title: string
  docType: string
  tags: string[]
  status: string
  source: string
  version: string | null
  embeddingStatus: string
  embeddedAt: string | null
  hitCount: number
  lastRetrievedAt: string | null
  createdByUserId: string | null
  createdByUser?: IAtlasUser | null
  updatedByUserId: string | null
  updatedByUser?: IAtlasUser | null
  createdAt: string
  updatedAt: string
  contentPreview?: string
}

export interface IAtlasDoc extends IAtlasDocSummary {
  content: string
  contentHash: string | null
}

export interface IAtlasDocsListData {
  data: IAtlasDocSummary[]
  total: number
  statusValues: string[]
}

export default combineReducers({
  list: createLoadingDataReducer<IAtlasDocsListData>(
    [actions.LIST_DOCS_REQUEST],
    [
      actions.ADD_DOC_REQUEST,
      actions.UPDATE_DOC_REQUEST,
      actions.DELETE_DOC_REQUEST,
      actions.REINGEST_DOC_REQUEST,
    ],
  ),

  selected(state: IAtlasDoc | null = null, action: IAction<IAtlasDoc>): IAtlasDoc | null {
    switch (action.type) {
      case actions.GET_DOC_SUCCESS:
        return action.data
      case actions.UPDATE_DOC_SUCCESS:
        if (state && action.data?.id === state.id) return action.data
        return state
      case actions.CLEAR_SELECTED_DOC:
      case actions.DELETE_DOC_SUCCESS:
        return null
      default:
        return state
    }
  },
})
